import { type FieldInputProps, type FormikErrors, type FormikTouched } from "formik"

export const MAX_64_CHARACTERS = 64
export const MAX_255_CHARACTERS = 255
export const MAX_500_CHARACTERS = 500
export const MAX_65535_CHARACTERS = 65535

export type FieldValueChange<T> = (
  field: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  shouldValidate?: boolean,
) => Promise<FormikErrors<T>> | Promise<void>

export type FieldTouchedChange<T> = (
  field: string,
  isTouched?: boolean,
  shouldValidate?: boolean,
) => Promise<FormikErrors<T>> | Promise<void>

export type SimpleFormik<T, K> = {
  values: T
  initialValues: T
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValues: (values: T) => void
  getFieldProps: (nameOrOptions: K) => FieldInputProps<any>
  setFieldValue: FieldValueChange<T>
  validateField?: (field: string) => void
  setFieldTouched: FieldTouchedChange<T>
  touched?: FormikTouched<T>
  errors?: FormikErrors<T>
  handleBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: string) => void
  handleChange?: (e: React.ChangeEvent, fieldName: string) => void
  submitForm: () => Promise<void>
  isSubmitting: boolean
}
